export var SupportedFileType;
(function (SupportedFileType) {
    SupportedFileType["MP3"] = "MP3";
    SupportedFileType["WMA"] = "WMA";
    SupportedFileType["WAV"] = "WAV";
    SupportedFileType["AIFF"] = "AIFF";
    SupportedFileType["AIF"] = "AIF";
    SupportedFileType["AIFC"] = "AIFC";
    SupportedFileType["RAM"] = "RAM";
    SupportedFileType["MP4"] = "MP4";
    SupportedFileType["AAC"] = "AAC";
    SupportedFileType["M4P"] = "M4P";
    SupportedFileType["MSV"] = "MSV";
    SupportedFileType["DVF"] = "DVF";
    SupportedFileType["RA"] = "RA";
    SupportedFileType["DSS"] = "DSS";
    SupportedFileType["AVI"] = "AVI";
    SupportedFileType["MWV"] = "MWV";
    SupportedFileType["MPG"] = "MPG";
    SupportedFileType["MOV"] = "MOV";
    SupportedFileType["MPEG"] = "MPEG";
    SupportedFileType["JPEG"] = "JPEG";
    SupportedFileType["JPE"] = "JPE";
    SupportedFileType["JPG"] = "JPG";
    SupportedFileType["GIF"] = "GIF";
    SupportedFileType["PNG"] = "PNG";
    SupportedFileType["WMV"] = "WMV";
    SupportedFileType["TIFF"] = "TIFF";
    SupportedFileType["TIF"] = "TIF";
    SupportedFileType["DOC"] = "DOC";
    SupportedFileType["DOT"] = "DOT";
    SupportedFileType["DOCX"] = "DOCX";
    SupportedFileType["PDF"] = "PDF";
    SupportedFileType["TXT"] = "TXT";
    SupportedFileType["RTF"] = "RTF";
    SupportedFileType["XLS"] = "XLS";
    SupportedFileType["XLSX"] = "XLSX";
    SupportedFileType["XLM"] = "XLM";
    SupportedFileType["XLA"] = "XLA";
    SupportedFileType["XLC"] = "XLC";
    SupportedFileType["XLT"] = "XLT";
    SupportedFileType["XLW"] = "XLW";
    SupportedFileType["M4A"] = "M4A";
    SupportedFileType["MPGA"] = "MPGA";
    SupportedFileType["MP2"] = "MP2";
    SupportedFileType["MP2A"] = "MP2A";
    SupportedFileType["M2A"] = "M2A";
    SupportedFileType["M3A"] = "M3A";
    SupportedFileType["EML"] = "EML";
    SupportedFileType["MIME"] = "MIME";
    SupportedFileType["MSG"] = "MSG";
    SupportedFileType["CSV"] = "CSV";
    SupportedFileType["MIE"] = "MIE";
    SupportedFileType["ZIP"] = "ZIP";
})(SupportedFileType || (SupportedFileType = {}));
export const supportedFileTypes = Object.values(SupportedFileType);
export const supportedVideoFileTypes = [
    SupportedFileType.MP4,
    SupportedFileType.AVI,
    SupportedFileType.MPG,
    SupportedFileType.MOV,
    SupportedFileType.MPEG,
    SupportedFileType.WMV
];
//# sourceMappingURL=SupportedFileType.js.map